const firstFoldconstants = {
    pdf : {
        pdf1: 'https://marketing.biddeasy.com/Assets/webAssets/IFS/1.5x%20Nifty%20MLD%20PPT_.pdf',
    },

    video : {
        url1 : 'https://www.youtube.com/watch?v=Zy7QKY7v3Vw&ab_channel=InCredMoney',
    }
}

export default firstFoldconstants;